import { CUSTOM_EVENT_NAME } from '@typesApp/AppEvent'
import { WidgetRenderEvent, WidgetCloseEvent, WidgetEventType, WidgetEvent, WidgetName } from '@typesApp/WidgetEvent'

const WIDGET_NAMES: WidgetName[] = [
  'dbWidget',
  'ctaWidget',
  'toggleWidget',
  'drawerWidget',
  'overviewWidget',
  'myClaimsWidget',
  'cartInterceptWidget',
]

/**
 * Handle custom widget events from commerce app
 */
export const initWidgetEventListener = () => {
  const renderWidget = (event: WidgetRenderEvent) => {
    const widgetName = event.widgetName
    const config = event.config
    if (WIDGET_NAMES.includes(widgetName)) {
      window.directBilling?.[widgetName]?.new(config)?.render()
    }
  }

  const closeWidget = (event: WidgetCloseEvent) => {
    const widgetName = event?.widgetName
    if (WIDGET_NAMES.includes(widgetName)) {
      window.directBilling?.[widgetName]?.close()
    }
  }

  const eventHandlers = {
    render: event => event.type === 'render' && renderWidget(event),
    close: event => event.type === 'close' && closeWidget(event),
  } as Record<WidgetEventType, (event: WidgetEvent) => void>

  const eventListener: EventListenerOrEventListenerObject = (event: Event) => {
    if (!isCustomEvent(event)) return

    const widgetEvent = event?.detail
    if (widgetEvent?.type) {
      eventHandlers[widgetEvent.type]?.(widgetEvent)
    }
  }

  document.addEventListener(CUSTOM_EVENT_NAME.WIDGET, eventListener)
}

const isCustomEvent = (event: Event): event is CustomEvent<WidgetEvent> => {
  return event instanceof CustomEvent
}
